import { findStringMatches } from '../findStringMatches';
function toSearchResults(matches) {
    return matches.map((match) => ({
        id: `plain-${match.start}`,
        payload: match,
    }));
}
export function createPlainEditorUniversalSearchProvider({ getEditor, }) {
    const searchText = (query) => {
        var _a, _b;
        const text = (_b = (_a = getEditor()) === null || _a === void 0 ? void 0 : _a.getText()) !== null && _b !== void 0 ? _b : '';
        return toSearchResults(findStringMatches(text, query.query, query.isCaseSensitive));
    };
    return {
        id: 'plain-editor',
        capabilities: {
            supportsReplace: true,
            supportsHighlightAll: true,
        },
        search: searchText,
        selectResult: (result, options) => {
            var _a, _b, _c;
            const payload = result.payload;
            if (!payload) {
                return;
            }
            (_a = getEditor()) === null || _a === void 0 ? void 0 : _a.setSelection(payload.start, payload.end, {
                focus: false,
                scrollIntoView: (_b = options === null || options === void 0 ? void 0 : options.scrollIntoView) !== null && _b !== void 0 ? _b : false,
                selectInEditor: (_c = options === null || options === void 0 ? void 0 : options.selectInEditor) !== null && _c !== void 0 ? _c : false,
            });
        },
        clear: () => {
            return;
        },
        replaceCurrentResult: async (result, query) => {
            var _a;
            const payload = result.payload;
            if (!payload) {
                return searchText(query);
            }
            await ((_a = getEditor()) === null || _a === void 0 ? void 0 : _a.replaceRange(payload.start, payload.end, query.replaceQuery));
            return searchText(query);
        },
        replaceAllResults: async (results, query) => {
            var _a;
            const ranges = results
                .map((result) => result.payload)
                .filter((payload) => payload != undefined);
            await ((_a = getEditor()) === null || _a === void 0 ? void 0 : _a.replaceAllRanges(ranges, query.replaceQuery));
            return searchText(query);
        },
    };
}
